import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RootModel from "../models/RootModel/RootModel";
import LinkButton from "../components/Button/LinkButton/LinkButton";
import TextButton from "../components/Button/TextButton/TextButton";
import { selectCurrentCategoryId, selectDataId, selectLocalities, selectStates } from '../store/feed/feedSelector.js'
import { TOPICS_SET_CURRENT_CATEGORY, TOPICS_SET_DATA_ID } from '../store/feed/feedSlice.js';
import { useDispatch, useSelector } from "react-redux";
export default function ExploreMobile() {
  const location = useLocation();
  const [isOpenParent, setIsOpenParent] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const state = useSelector((state) => state);
  const categoryId = selectCurrentCategoryId(state);
  const dataId = selectDataId(state);
  const states = selectStates(state);
  const localities = selectLocalities(state);
  const dispatch = useDispatch();
  
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const topicCategoryId = queryParams.get('topic_category_id') || 1;
    dispatch(TOPICS_SET_CURRENT_CATEGORY(topicCategoryId));
    const topicDataId = queryParams.get('data_id');
    if (topicCategoryId > 1) {
      if (!topicDataId) {
        setIsOpen(true)
      }
      else {
        dispatch(TOPICS_SET_DATA_ID(topicDataId))
      }
    }

  }, [location.search])

  const navigate = useNavigate()
  const changeUrl = () => {
    let url = location.pathname;
    if(url == '/explore'){
      url = '/explore/opened-projects'
    }
    return url;
     
  }
  const renderStates = (
    <div className='sl-btn-container'>
      {states.map(el =>

        <LinkButton key={el.id}
          linkText={el.name}
          href={changeUrl() + location.search + '&data_id='+el.id}
          className="tweet-btn w-100"
          onClick={() => {
            setIsOpen(false)
          }}
        />
      )}
    </div>
  );

  

  const renderLocalities = (
    <div className='sl-btn-container'>
      {localities.map(el =>

        <LinkButton key={el.id}
          linkText={el.name}
          href={changeUrl() + location.search + '&data_id='+el.id}
          className="tweet-btn w-100"
          onClick={() => {
            setIsOpen(false)
          }}
        />
      )}
    </div>
  );
  return (
    <>
      {isOpen && <div className="login-flow-page">
        <RootModel navigateTo={'/explore/opened-projects?topic_category_id=' + categoryId} setAddonCloseCallback={() => {
          setIsOpen(false);
          navigate('/explore/opened-projects?topic_category_id=1')
        }}>
          {categoryId == 2 && renderStates}
          {categoryId == 3 && renderLocalities}
        </RootModel>
      </div>}
      {isOpenParent && <div className="login-flow-page">
        <RootModel bodyClass='ex-mb' navigateTo={'/explore/opened-projects?topic_category_id=' + categoryId} setAddonCloseCallback={() => {
          setIsOpenParent(false);
          navigate('/explore/opened-projects?topic_category_id=1')
        }}>
            <div className="sm-btn-container">
            <LinkButton
          linkText={'المجلس الاتحادي'}
          href={'/explore/opened-projects?topic_category_id=1'}
          className="tweet-btn w-100"
          onClick={() => {
            setIsOpen(false)
          }}
        />
        <LinkButton
          linkText={'الولايات'}
          href={'/explore?topic_category_id=2'}
          className="tweet-btn w-100"
          onClick={() => {
            setIsOpen(false)
          }}
        />
        <LinkButton
          linkText={'المحليات'}
          href={'/explore?topic_category_id=3'}
          className="tweet-btn w-100"
          onClick={() => {
            setIsOpen(false)
          }}
        />      
            </div>
          
        </RootModel>
      </div>}
    </>
  );
}
